import { IssuePriority } from "../../models";

export const issuePriorityText = {
    [IssuePriority.LOW]: "Low",
    [IssuePriority.MEDIUM]: "Medium",
    [IssuePriority.HIGH]: "High",
};